import { useQuery } from '@tanstack/react-query';
import api from '../lib/axios';
import useProjectStore from '../stores/projectStore';

function useDashboard(kind, days) {
  const projectId = useProjectStore((s) => s.currentProjectId);
  return useQuery({
    queryKey: ['analytics', kind, projectId, days],
    queryFn: async () => {
      const { data } = await api.get(`/projects/${projectId}/analytics/${kind}`, {
        params: { days },
        skipProject: true,
      });
      return data;
    },
    enabled: !!projectId,
    retry: false,
  });
}

export function useGa4Dashboard(days = 28) {
  return useDashboard('ga4', days);
}

export function useTrackingProjectDashboard(days = 28) {
  return useDashboard('tracking', days);
}
